import type { FaireProductEntity } from "../../entity_types/product";

export const p_s4bzxpbknj: FaireProductEntity = {
  token: "p_s4bzxpbknj",
  type: "product",
  name: "Rufia - Thick Mid-calf Socks for Winter",
  brandName: "Funkyrel\u00ae Atzbranding Limited",
  imageUrl:
    "https://cdn.faire.com/fastly/38ae1c4852c58d7f65c3479604bc964ad17c68f258511add2b96195c6d1261cf.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/a360dc4f7990bb390bd6ba6ae559411ba52a186d489ee66b1a1d1a8b7f6a93ae.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
